<div style="height:80%">
<div class="du-mail-popup-header-bg d-flex">
    <h1 class="header-title">Privacy Policy</h1>
    <mat-icon class="close-icon" (click)="closePopup()">close</mat-icon>
</div>
<div class="container align-items-center">


    <span><strong>Effective Date:</strong>{{ currentDate }}</span>

    <h2>1. Introduction</h2>
    <span>
        SCRAII ("we," "us," or "our") is committed to protecting the privacy of its users ("you" or "your").
        This Privacy Policy explains how we collect, use, and share your information when you use the email integration
        feature within the SCRAII application.
    </span>

    <h2>2. Information We Collect</h2>
    <ul>
        <li><strong>Email Address:</strong> Your email address used for login and sending/receiving emails.</li>
        <li><strong>Email Content:</strong> We may access and store the content of your emails, including the subject
            line, sender, recipient(s), body, attachments, and associated metadata (e.g., timestamps). This is necessary
            for email integration to function.</li>
        <li><strong>Email Headers:</strong> We may collect information from email headers, such as IP addresses,
            sender/recipient server information, and other technical details.</li>
        <li><strong>Authentication Information:</strong> We store credentials or tokens necessary to access your email
            account (using secure authentication methods like OAuth). We do not store your email password directly.</li>
        <li><strong>Usage Data:</strong> We may collect information about how you use the email integration feature,
            such as the frequency of use, types of actions performed (sending, receiving, deleting), and any errors
            encountered.</li>
    </ul>

    <h2>3. How We Use Your Information</h2>
    <ul>
        <li><strong>Providing the Service:</strong> To enable the email integration functionality within SCRAII,
            including sending, receiving, managing, and organizing your emails.</li>
        <li><strong>Improving the Service:</strong> To analyze usage patterns and identify areas for improvement in the
            email integration feature.</li>
        <li><strong>Security:</strong> To protect your email account and our systems from unauthorized access, fraud,
            and abuse.</li>
        <li><strong>Communication:</strong> We may use your email address to send you service-related notifications,
            updates, or important information about the email integration.</li>
    </ul>

    <h2>4. How We Share Your Information</h2>
    <ul>
        <li><strong>Service Providers:</strong> We may engage third-party service providers (e.g., email providers, data
            storage providers) to assist us in providing the email integration feature. These providers are
            contractually obligated to protect your information.</li>
        <li><strong>Legal Compliance:</strong> We may disclose your information if required by law, court order, or
            government request.</li>
        <li><strong>Business Transfers:</strong> In the event of a merger, acquisition, or sale of all or a portion of
            our assets, your information may be transferred as part of that transaction.</li>
    </ul>

    <h2>5. Data Security</h2>
    <span>
        We implement reasonable security measures to protect your email information from unauthorized access, use, or
        disclosure.
        However, no method of transmission over the Internet, or method of electronic storage, is 100% secure.
    </span>

    <h2>6. Data Retention</h2>
    <span>
        We will retain your email information for as long as your SCRAII account is active or as needed to provide the
        email integration feature.
        You can delete your email integration and request that we delete your associated data, subject to legal
        requirements.
    </span>

    <h2>7. Changes to this Privacy Policy</h2>
    <span>
        We may update this Privacy Policy from time to time. We will notify you of any material changes.
    </span>

    <h2>8. Contact Us</h2>
    <span>
        If you have any questions about this Privacy Policy, please contact us at:
        <a href="mailto:scraii-support@dataunveil.com">{{'scraii-support@dataunveil.com'}}</a>
    </span>

    <div class="buttons d-flex justify-content-end gap-2">
        <button class="ok" mat-flat-button color="primary" (click)="closePopup()">Ok</button>
    </div>
</div>
</div>